<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.index')">Events
            </inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.show', [eventInfo.id])">
                {{ eventInfo.name }}
            </inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            <inertia-link class="text-indigo-400 hover:text-indigo-600"
                          :href="route('attendee-import.index', [eventInfo.id])">Import Attendees
            </inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            Batch #{{ batch.id }}
        </h1>

        <steps class="mb-6" current-step="validate" :batch-id="batch.id"></steps>

        <info-box>
            The database has encountered an error parsing the imported data and requires assistance to proceed.
            This usually occurs if the data is in an unrecognized format (particularly dates) or if the imported value
            does not exist in a dropdown field.
            Please provide a new value for each of the errors identified below.
        </info-box>

        <table-wrapper :headers="['Given Name', 'Surname', 'Field', 'Original Value', 'New Value']" class="mb-6">
            <tbody v-for="record in records" :key="'record-' + record.id">
                <table-row v-for="(error, errorIdx) in record.errors" :key="'error-' + record.id + '-' + error.table_field" :title="error.message">
                    <table-cell v-if="errorIdx === 0" :rowspan="record.errors.length">
                        {{ record.given_name }}
                    </table-cell>
                    <table-cell v-if="errorIdx === 0" :rowspan="record.errors.length">
                        {{ record.surname }}
                    </table-cell>
                    <table-cell>{{ error.table }}.{{ error.field }}</table-cell>
                    <table-cell>{{ error.original }}</table-cell>
                    <table-cell colspan="2">
                        <field-input class="w-full" v-model="form.updatedValues[record.id][error.table_field]" :table-field="error.table_field"></field-input>
                    </table-cell>
                </table-row>
            </tbody>
            <table-row v-if="records.length === 0">
                <table-cell colspan="6">
                    No Errors Found
                </table-cell>
            </table-row>
        </table-wrapper>

        <div class="mb-6 flex items-center">
            <button class="btn-red" tabindex="-1" type="button" @click="destroy">Delete Batch</button>
            <button class="btn-indigo ml-auto" type="button" @click="submit">
                Continue
            </button>
        </div>

    </div>
</template>

<script>
import Layout from "@/Shared/Layout"
import Icon from "@/Shared/Icon"
import TableWrapper from "@/Shared/Table/TableWrapper"
import TableRow from "@/Shared/Table/TableRow"
import TableCell from "@/Shared/Table/TableCell"
import TableCellEnd from "@/Shared/Table/TableCellEnd"
import Steps from "./ImportSteps.vue"
import TextInput from "../../Shared/TextInput.vue";
import FieldInput from "../../Shared/FieldInput.vue";
import InfoBox from "../../Shared/InfoBox.vue";

export default {
    metaInfo: {title: "Validate Data"},
    components: {
        InfoBox,
        TextInput,
        FieldInput,
        Icon,
        TableWrapper,
        TableRow,
        TableCell,
        TableCellEnd,
        Steps,
    },
    layout: Layout,
    props: {
        eventInfo: Object,
        batch: Object,
        records: Array,
    },
    data() {
        return {
            form: this.$inertia.form({
                updatedValues: {},
            }),
        }
    },
    created() {
        let updatedValues = {}
        this.records.forEach((record) => {
            updatedValues[record.id] = {}
            record.errors.forEach((error) => {
                updatedValues[record.id][error.table_field] = null
            })
        })
        this.form.updatedValues = updatedValues
    },
    methods: {
        destroy() {
            if (confirm('Are you sure you want to delete this attendee import batch?')) {
                this.$inertia.delete(this.route('attendee-import.destroy', [this.batch.id]))
            }
        },
        submit() {
            this.form.put(this.route('attendee-import-validate.update', [this.batch.id]))
        }
    },
}
</script>
